import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React from "react";

import useSingleSelectFilter from "components/pages/dashboard/surgery_types_procedures/filter/cards/useSingleSelectFilter";

const SingleSelectField = ({ filter }) => {
  const { options, value, onChange } = useSingleSelectFilter(filter);
  const labelId = `${filter.field}-select-label`;
  const inputLabel = filter.inputLabel ?? filter.label;

  return (
    <Box>
      {filter.cardTitle && (
        <Typography variant="body1" sx={{ fontWeight: 600, mb: 1.5 }}>
          {filter.label}
        </Typography>
      )}
      <FormControl fullWidth>
        <InputLabel id={labelId} shrink>
          {inputLabel}
        </InputLabel>
        <Select
          labelId={labelId}
          label={inputLabel}
          value={value}
          displayEmpty
          notched
          onChange={(event) => onChange(event.target.value)}
        >
          <MenuItem value="">{filter.placeholder ?? "Any"}</MenuItem>
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SingleSelectField;
